import * as ActionType from 'actions/ActionTypeConstants';

export const setMemberViewSearchField = {
  start: (memberViewSearchField: string) => ({
    type: ActionType.HOME_SET_MEMBER_VIEW_SEARCH_FIELD as typeof ActionType.HOME_SET_MEMBER_VIEW_SEARCH_FIELD,
    payload: { memberViewSearchField },
  }),
};
